export function EditDraft(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.81283 2.52871C5.57117 1.56355 6.73066 1 7.95811 1H14C15.6569 1 17 2.34315 17 4V5C17 5.55228 16.5523 6 16 6C15.4477 6 15 5.55228 15 5V4C15 3.44772 14.5523 3 14 3H9V8C9 9.65685 7.65685 11 6 11H2V20C2 20.5523 2.44772 21 3 21H14C14.5523 21 15 20.5523 15 20V17C15 16.4477 15.4477 16 16 16C16.5523 16 17 16.4477 17 17V20C17 21.6569 15.6569 23 14 23H3C1.34315 23 0 21.6569 0 20V10.0376L0.000176499 10C0.000176499 9.1281 0.292822 8.28145 0.831503 7.59586L4.81283 2.52871ZM6.38547 3.76436C6.55513 3.54842 6.76495 3.3727 7 3.24443V8C7 8.55228 6.55228 9 6 9H2.2902C2.33173 8.93157 2.3775 8.86541 2.42736 8.80195L6.38547 3.76436Z"
          fill="currentColor"
        />
        <path
          d="M11.4098 17.4198C11.4046 17.2035 11.2305 17.0294 11.0142 17.0242L10.3867 17.0089C10.1704 17.0036 9.99637 16.8295 9.99109 16.6133L9.9758 15.9857C9.97052 15.7694 9.79646 15.5954 9.58019 15.5901L8.56646 15.5654L8.00296 18.7584C7.99846 18.7839 7.9991 18.8103 8.00485 18.836C8.02891 18.9438 8.1349 19.0158 8.2416 18.997L11.4346 18.4335L11.4098 17.4198Z"
          fill="currentColor"
        />
        <path
          d="M12.1175 17.7506L21.678 8.18999L18.8099 5.32187L9.24936 14.8825L10.2631 14.9072C10.4794 14.9125 10.6534 15.0865 10.6587 15.3028L10.674 15.9304C10.6793 16.1466 10.8533 16.3207 11.0696 16.326L11.6971 16.3413C11.9134 16.3465 12.0875 16.5206 12.0927 16.7369L12.1175 17.7506Z"
          fill="currentColor"
        />
        <path
          d="M23.7267 6.14128C24.1039 5.76413 24.0886 5.13736 23.6926 4.74135L22.2585 3.30729C21.8625 2.91129 21.2358 2.89601 20.8586 3.27317L19.4928 4.63897L22.3609 7.50709L23.7267 6.14128Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
